export const trackEvent = (eventName, categoryName, labelName, value, user_id, user_email) => {

  if (process.env.REACT_APP_IS_TRACKING_REQUIRED === 'true' && window.gtag) {
      window.gtag("event", eventName, {
      event_category: categoryName,
      event_label: labelName,
      value: value,
      category:categoryName,
      label:labelName,
      app_user_id: user_id,
      app_user_email: user_email
    });
  }
};